module.exports = __webpack_public_path__ + "static/media/galerija_2017 (1).28ea7067.jpg";